import { render, staticRenderFns } from "./PtrLoading.vue?vue&type=template&id=38ab8e70&scoped=true&"
var script = {}
import style0 from "./PtrLoading.vue?vue&type=style&index=0&id=38ab8e70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab8e70",
  null
  
)

export default component.exports